import { render, staticRenderFns } from "./PedidosMayoreoFormComponent.vue?vue&type=template&id=408a4678&"
import script from "./PedidosMayoreoFormComponent.vue?vue&type=script&lang=js&"
export * from "./PedidosMayoreoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports